import React from 'react';
import ProductContent from './Components';

const ProductsPage: React.FC = () => {
  return <ProductContent />;
};

export default ProductsPage;
